import { createFileRoute, Outlet, redirect, stripSearchParams } from "@tanstack/react-router";

import { authQueries } from "@/api/resources/auth/queries";
import { deploymentsQueries } from "@/api/resources/deployments/queries";
import { deploymentsToWorkspacesQueries } from "@/api/resources/deploymentsToWorkspaces/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import { defaultGlobalFilters, globalFiltersSearchSchema } from "@/providers/globalFiltersConfig";

export const Route = createFileRoute("/_auth")({
  validateSearch: globalFiltersSearchSchema,
  search: {
    middlewares: [stripSearchParams(defaultGlobalFilters)],
  },
  beforeLoad: async ({ context }) => {
    // redirect to login if no session exists
    const session = await context.queryClient.ensureQueryData(authQueries.getAuthSession());
    if (!session) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.pathname,
        },
      });
    }
    return { session };
  },
  loader: async ({ context }) => {
    await Promise.allSettled([
      context.queryClient.ensureQueryData(workspacesQueries.listAll()),
      context.queryClient.ensureQueryData(deploymentsQueries.listAll()),
      context.queryClient.ensureQueryData(deploymentsToWorkspacesQueries.listAll()),
    ]);
  },
  component: () => <Outlet />,
});
